import { createFeatureSelector, createSelector } from "@ngrx/store";
import { appFeatureKey, AppState } from "./app.reducer";

export const selectAppState = createFeatureSelector<AppState>(appFeatureKey);

export const selectToolbarTitle = createSelector(selectAppState, (state) => state.toolbarTitle);
export const selectToolbarIcon = createSelector(selectAppState, (state) => state.toolbarIcon);
export const selectAppIsLoading = createSelector(selectAppState, (state) => state.appIsLoading);
export const selectAppError = createSelector(selectAppState, (state) => state.appError);
export const selectSidebarCollapsedState = createSelector(selectAppState, (state) => state.sidebarCollapsed);
export const selectRememberedUser = createSelector(selectAppState, (state) => state.rememberedUser);
export const selectPagination = createSelector(selectAppState, (state) => state.pageSize);
export const selectLoggedIn = createSelector(selectAppState, (state) => state.loggedIn);